import React from 'react'
import ReactDOM from 'react-dom'
import App from './js/App'
import * as serviceWorker from './serviceWorker'
import './sass/main.sass'
import 'materialize-css/dist/css/materialize.css'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
import { createStore, combineReducers } from 'redux'
import { ReactReduxFirebaseProvider } from 'react-redux-firebase'
import { createFirestoreInstance, firestoreReducer } from 'redux-firestore'
import { Provider } from 'react-redux'

const firebaseConfig = {
  apiKey: 'AIzaSyDPnwxAREbsygetuTf_buyuf-7ZMIsHclk',
  authDomain: 'soham-blog.firebaseapp.com',
  databaseURL: 'https://soham-blog.firebaseio.com',
  projectId: 'soham-blog',
  storageBucket: 'soham-blog.appspot.com',
  messagingSenderId: '546781216194',
  appId: '1:546781216194:web:65b9bde4aea664330c6a5b',
  measurementId: 'G-MB72XQ84RS'
}
const rrfConfig = { userProfile: 'users', useFirestoreProfile: true }

firebase.initializeApp(firebaseConfig)
firebase.firestore()



const reducer = combineReducers({
  firestore: firestoreReducer
})

const initState = {}
const store = createStore( reducer, initState )

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance
}

ReactDOM.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      <App />
    </ReactReduxFirebaseProvider>
  </Provider>,
  document.getElementById('root')
)
serviceWorker.unregister()